import React, { useState } from 'react';
import '../styles/PaginaVendaSaas.css';

const SALES_WHATSAPP = '5531920065794';

export default function CheckoutSaas() {
  const [form, setForm] = useState({ name: '', email: '', cpfCnpj: '', plan: 'nuvem', cycle: 'monthly' });
  const [state, setState] = useState({ loading: false, error: '', result: null });
  const productLogo = `${process.env.PUBLIC_URL || ''}/assets/nivora-logo.png`;
  const submit = async (event) => {
    event.preventDefault(); setState({ loading: true, error: '', result: null });
    try {
      const response = await fetch('/api/public/asaas/checkout', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(form) });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.message || 'Não foi possível preparar a assinatura.');
      setState({ loading: false, error: '', result: payload.data });
    } catch (error) { setState({ loading: false, error: error.message, result: null }); }
  };

  return (
    <div className="sales-page">
      <header className="sales-topbar">
        <a className="sales-brand" href="/" aria-label="Nivora ERP">
          <span><img src={productLogo} alt="" aria-hidden="true" /></span>
          Nivora ERP
        </a>
        <nav className="sales-nav" aria-label="Navegação da contratação">
          <a href="/">Voltar para a oferta</a>
          <a href="/login" className="sales-nav-cta">Entrar</a>
        </nav>
      </header>

      <main>
        <section className="sales-contact" style={{ minHeight: 'calc(100vh - 72px)' }}>
          <div>
            <span className="sales-section-label">Implantação assistida</span>
            <h2>Comece por R$ 49 por mês</h2>
            <p>
              Antes da cobrança, confirmamos se o Nivora ERP atende sua operação, seu computador
              Windows e os dispositivos que você pretende usar. Depois combinamos a instalação e
              o treinamento inicial.
            </p>
            <p>
              A oferta inicial cobre um estabelecimento e uma instalação. Equipamentos, serviços
              fiscais de terceiros e customizações não estão incluídos na mensalidade.
            </p>
          </div>
          <div className="sales-form">
            <h3>Fale com a implantação</h3>
            <p>Informe seus dados. O Nivora prepara a assinatura recorrente no ambiente seguro do Asaas.</p>
            <form onSubmit={submit} className="sales-form-fields">
              <input id="checkout-nome" name="name" required placeholder="Nome completo" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input id="checkout-email" name="email" required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input id="checkout-cpf-cnpj" name="cpfCnpj" required placeholder="CPF ou CNPJ" value={form.cpfCnpj} onChange={(e) => setForm({ ...form, cpfCnpj: e.target.value })} />
              <select id="checkout-plano" name="plan" value={form.plan} onChange={(e) => setForm({ ...form, plan: e.target.value })}><option value="nuvem">Nuvem · R$ 149/mês + WBUY</option><option value="local">Local · R$ 49/mês</option></select>
              <select id="checkout-ciclo" name="cycle" value={form.cycle} onChange={(e) => setForm({ ...form, cycle: e.target.value })}><option value="monthly">Mensal</option><option value="quarterly">Trimestral</option><option value="semiannual">Semestral</option><option value="annual">Anual</option></select>
              <button className="sales-submit-link" type="submit" disabled={state.loading}>{state.loading ? 'Preparando...' : 'Continuar para pagamento'}</button>
            </form>
            {state.error && <small role="alert">{state.error}</small>}
            {state.result && <small>Assinatura criada. {state.result.invoiceUrl ? <a href={state.result.invoiceUrl} target="_blank" rel="noreferrer">Abrir cobrança</a> : 'O Asaas enviará a cobrança ao e-mail informado.'}</small>}
            <small>Se preferir, a implantação assistida continua disponível pelo WhatsApp {SALES_WHATSAPP}.</small>
          </div>
        </section>
      </main>
    </div>
  );
}
